import React from 'react';
import PropTypes from 'prop-types';
import './AlertCloseButton.less';
import {SVGIcon} from '@homeaway/react-svg';
import {CLOSE__16} from '@homeaway/svg-defs';

function AlertCloseButton(props) {
    return (
        <button type="button" className="Alert__close" onClick={props.onClick}>
            <span className="Alert__close-flex">
                <SVGIcon inlineFlex markup={CLOSE__16} />
                <span className="sr-only">{props.closeText}</span>
            </span>
        </button>
    );
}

AlertCloseButton.propTypes = {
    closeText: PropTypes.string,
    onClick: PropTypes.func
};

export default AlertCloseButton;
